import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import {CSSTransition} from "react-transition-group"
import "../Drawer/Drawer.css"
import DynamicSVG from '../DynamicSVG/DynamicSVG'
interface Props{
  children?: JSX.Element,
  isOpen: boolean,
  toggleDrawer:(()=>void)
}
export default function Drawer({children,isOpen,toggleDrawer}:Props) {

  
  return ReactDOM.createPortal(
    <CSSTransition unmountOnExit in={isOpen} timeout={300} classNames="Drawer-Background">
      <div className={`Drawer-Background`}>
      <div className='Drawer-Container'>
        <button className='Close-Btn' onClick={toggleDrawer}>X</button>
        {children}
      </div>
      </div>
    </CSSTransition>
    
    ,document.getElementById("root") as HTMLElement)
}
